export default __webpack_public_path__ + "static/eew-public-workshop-c122e9b6efd979901b9f972f140cf139.png";